import { runCommand } from './command-gateway';

interface ClientErrorReport {
  /**
   * De dónde viene. `web-session`: falló comprobar la sesión. `web-uncaught`:
   * un error o promesa rechazada que nadie manejó (ver `GlobalErrorReporter`).
   * `web-chat`: un error atrapado en La Taberna (`/chat`). `web-app`: un error
   * atrapado en cualquier otra parte del sitio que antes solo iba a
   * `console.error`. Sumar otro valor acá y en `SOURCES` de
   * `report_client_error` (backend) cuando haga falta uno nuevo — la regla
   * es que todo lo que el cliente detecte como error se reporte, no que
   * cada caso nuevo se acuerde de hacerlo por su cuenta.
   */
  source: 'web-session' | 'web-uncaught' | 'web-chat' | 'web-app';
  message: string;
  operation?: string;
  details?: unknown;
  errorCode?: string;
  route?: string;
  context?: Record<string, unknown>;
  /** Por defecto `'error'` del lado del backend. */
  level?: 'warning' | 'error' | 'critical';
}

/**
 * Deja un error del navegador en `frontend_errors`, visible en una sección
 * propia de "Estado del sistema", separada de los errores internos del
 * servidor que usa `update-engine`.
 *
 * Nunca lanza: si el reporte en sí falla (por ejemplo, el mismo corte de
 * red que se está reportando), no debe tapar el error original que lo
 * disparó. Es best-effort a propósito.
 */
export function reportClientError(report: ClientErrorReport): void {
  const route = report.route ?? (typeof window !== 'undefined' ? window.location.pathname : undefined);
  const context = {
    ...report.context,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
  };
  void runCommand('report_client_error', { ...report, route, context }).catch(() => {
    // No hay nada más que hacer del lado del cliente si ni esto llegó.
  });
}
